import { useLocale } from "../hooks/useLocale";
import { msg } from "../locales/translate";
import { Box, HBox } from "@ui/box/Box";
import { Typo } from "@ui/text/Typo";
import { ITheme } from "@ui/theme/GlobalTheme";
import { Fragment, useEffect, useState } from "react";
import { GD } from "src/GD";
import { IClient } from "src/services/ClientService";
import { IBreadcrumbs, INav, useBreadcrumbs, useRouter } from "src/services/Router";
import { useTheme } from "styled-components";
import { hasAnyRole, hasRole } from "src/permissions";
import { IconArrowRight } from "./conponents/icons/IconArrowRight";
import { IconHome } from "./conponents/icons/IconHome";
import { IAcquirerChannel, ITerminal } from "src/types/types";

const openProjectSelect = () => {
	location.href = "/";
};

export const Node = ({ label, onClick, last }: { label: string; onClick: (() => void) | null; last: boolean }) => {
	useLocale();
	const theme = useTheme() as ITheme;

	return (
		<Typo
			onClick={() => onClick && onClick()}
			sx={{
				cursor: "pointer",
				borderRadius: "7px",
				paddingTop: "5px",
				paddingBottom: "5px",
				paddingRight: "10px",
				paddingLeft: "10px",
				fontSize: "0.9rem",
				color: last ? "#ff7b00" : theme.colors.textPrimary,

				"&:hover": {
					backgroundColor: theme.colors.textPrimary + "25",
				},
			}}>
			{label}
		</Typo>
	);
};

export const ClientNode = ({ data, onClick, last }: { data: { path: string; node: INav }; onClick: (() => void) | null; last: boolean }) => {
	useLocale();
	const [loaded, setLoaded] = useState<{ path: string; client?: IClient }>();
	const clientPath = data.path;

	useEffect(() => {
		let active = true;
		void GD.REQ_CLIENT.request({ clientID: parseInt(clientPath, 10) }).then(
			response => { if (active) setLoaded({ path: clientPath, client: response?.error ? undefined : response?.data }); },
			() => { if (active) setLoaded({ path: clientPath }); },
		);
		return () => { active = false; };
	}, [clientPath]);

	const client = loaded?.path === clientPath ? loaded.client : undefined;
	return <Node label={client?.name || msg("templateClient_1cf8a7e9", { v0: clientPath })} onClick={onClick} last={last} />;
};

export const MerchantNode = ({
	data,
	clientId,
	last,
}: // onClick,
{
	data: { path: string; node: INav };
	clientId: string;
	last: boolean;
	// onClick: (() => void) | null;
}) => {
	useLocale();
	const router = useRouter();
	const [merchant, setMerchant] = useState<IClientGroup>();

	useEffect(() => {
		loadMerchant();
	}, []);

	const loadMerchant = async () => {
		const merchantReq = await GD.REQ_GROUP.request({
			groupID: parseInt(data.path, 10),
			clientID: parseInt(getClientId(), 10),
		});
		if (merchantReq?.data) {
			setMerchant(merchantReq.data);
		}
	};

	const getClientId = () => {
		//!TODO:;
		// if((data.node as any)['parent'])
		// {
		// 	const parent:INav = (data.node as any)['parent'];
		// 	if(parent)
		// 	{

		// 	}
		// }

		return clientId;
	};

	const openMerchant = () => {
		let params = undefined;
		if (data.node.path.indexOf(":") !== -1) {
			params = {
				[data.node.path.slice(data.node.path.indexOf(":") + 1)]: data.path,
			};

			params.cid = getClientId().toString();
		}
		return () => {
			router.navigate(data.node.id, params);
			//presenter.navChange(data.node.id, params);
		};
	};

	return <Node label={merchant?.name ?? ""} onClick={openMerchant()} last={last} />;
};

export const AcquirerNode = ({
	data,
	last,
	onClick,
}: // onClick,
{
	data: { path: string; node: INav };
	last: boolean;
	onClick: (() => void) | null;
	// onClick: (() => void) | null;
}) => {
	useLocale();
	//const router = useRouter();
	const [acquirer, setAcquirer] = useState<IAcquirer>();

	useEffect(() => {
		loadAcquirer();
	}, []);

	const loadAcquirer = async () => {
		const acquirerReq = await GD.REQ_ACQUIRER.request({
			acquirerID: parseInt(data.path, 10),
		});
		if (acquirerReq?.data) {
			setAcquirer(acquirerReq.data);
		}
	};

	// const openMerchant = () => {
	// 	let params = undefined;
	// 	if (data.node.path.indexOf(":") != -1) {
	// 		params = {
	// 			[data.node.path.slice(data.node.path.indexOf(":") + 1)]:
	// 				data.path,
	// 		};
	// 		params.cid = getClientId().toString();
	// 	}
	// 	return () => {
	// 		router.navigate(data.node.id, params);
	// 		//presenter.navChange(data.node.id, params);
	// 	};
	// };

	return <Node label={acquirer?.name ?? ""} onClick={onClick} last={last} />;
};

export const TerminalNode = ({
	data,
	last,
	onClick,
}: // onClick,
{
	data: { path: string; node: INav };
	last: boolean;
	onClick: (() => void) | null;
	// onClick: (() => void) | null;
}) => {
	useLocale();
	//const router = useRouter();
	const [terminal, setTerminal] = useState<ITerminal>();

	useEffect(() => {
		loadTerminal();
	}, []);

	const loadTerminal = async () => {
		const terminalReq = await GD.REQ_TERMINAL.request({
			terminalID: parseInt(data.path, 10),
		});
		if (terminalReq?.data) {
			setTerminal(terminalReq.data);
		}
	};

	return <Node label={terminal?.name ?? ""} onClick={onClick} last={last} />;
};

export const AcquirerChannelNode = ({
	data,
	last,
	acquirerId,
}: // onClick,
{
	data: { path: string; node: INav };
	last: boolean;
	acquirerId: string;
	// onClick: (() => void) | null;
}) => {
	useLocale();
	const router = useRouter();
	const [acquirerChannel, setAcquirerChannel] = useState<IAcquirerChannel>();

	useEffect(() => {
		loadAcquirerChannel();
	}, []);

	const loadAcquirerChannel = async () => {
		const acquirerReq = await GD.REQ_ACQUIRER_CHANNEL.request({
			channelId: parseInt(data.path, 10),
			acquirerID: parseInt(acquirerId, 10),
		});
		if (acquirerReq?.data) {
			setAcquirerChannel(acquirerReq.data);
		}
	};

	const getAcquirerId = () => {
		//!TODO:;
		// if((data.node as any)['parent'])
		// {
		// 	const parent:INav = (data.node as any)['parent'];
		// 	if(parent)
		// 	{

		// 	}
		// }

		return acquirerId;
	};

	const openAcquirerChannel = () => {
		let params = undefined;
		if (data.node.path.indexOf(":") !== -1) {
			params = {
				[data.node.path.slice(data.node.path.indexOf(":") + 1)]: data.path,
			};
			params.cid = getAcquirerId().toString();
		}
		return () => {
			router.navigate(data.node.id, params);
		};
	};

	return <Node label={acquirerChannel?.title ?? ""} onClick={openAcquirerChannel} last={last} />;
};

// export const AcquirerTerminalNode = ({
// 	data,
// 	last,
// 	acquirerId,
// }: // onClick,
// {
// 	data: { path: string; node: INav };
// 	last: boolean;
// 	acquirerId: string;
// 	// onClick: (() => void) | null;
// }) => {
// 	const router = useRouter();
// 	const [acquirerChannel, setAcquirerChannel] = useState<IAcquirerChannel>();

// 	useEffect(() => {
// 		loadAcquirerChannel();
// 	}, []);

// 	const loadAcquirerChannel = async () => {
// 		const acquirerReq = await GD.REQ_ACQUIRER_CHANNEL.request({
// 			channelId: parseInt(data.path),
// 			acquirerID: parseInt(acquirerId),
// 		});
// 		if (acquirerReq?.data) {
// 			setAcquirerChannel(acquirerReq.data);
// 		}
// 	};

// 	const getAcquirerId = () => {
// 		//!TODO:;
// 		// if((data.node as any)['parent'])
// 		// {
// 		// 	const parent:INav = (data.node as any)['parent'];
// 		// 	if(parent)
// 		// 	{

// 		// 	}
// 		// }

// 		return acquirerId;
// 	};

// 	const openAcquirerChannel = () => {
// 		let params = undefined;
// 		if (data.node.path.indexOf(":") != -1) {
// 			params = {
// 				[data.node.path.slice(data.node.path.indexOf(":") + 1)]: data.path,
// 			};
// 			params.cid = getAcquirerId().toString();
// 		}
// 		return () => {
// 			router.navigate(data.node.id, params);
// 		};
// 	};

// 	return <Node label={acquirerChannel?.title ?? ""} onClick={openAcquirerChannel} last={last} />;
// };

export const MerchantChannelNode = ({
	data,
	last,
	merchantId,
}: // onClick,
{
	data: { path: string; node: INav };
	last: boolean;
	merchantId: string;
	// onClick: (() => void) | null;
}) => {
	useLocale();
	const router = useRouter();
	const [acquirerChannel, setAcquirerChannel] = useState<IAcquirerChannel>();

	useEffect(() => {
		loadMerchantChannel();
	}, []);

	const loadMerchantChannel = async () => {
		const acquirerReq = await GD.REQ_MERCHANT_CHANNEL.request({
			channelId: parseInt(data.path, 10),
			merchantId: parseInt(merchantId, 10),
		});
		if (acquirerReq?.data) {
			setAcquirerChannel(acquirerReq.data);
		}
	};

	const getMerchantId = () => {
		//!TODO:;
		// if((data.node as any)['parent'])
		// {
		// 	const parent:INav = (data.node as any)['parent'];
		// 	if(parent)
		// 	{

		// 	}
		// }

		return merchantId;
	};

	const openMerchantChannel = () => {
		let params = undefined;
		if (data.node.path.indexOf(":") !== -1) {
			params = {
				[data.node.path.slice(data.node.path.indexOf(":") + 1)]: data.path,
			};
			params.cid = getMerchantId().toString();
		}
		return () => {
			router.navigate(data.node.id, params);
		};
	};

	return <Node label={acquirerChannel?.title ?? msg("channel_69e36568")} onClick={openMerchantChannel()} last={last} />;
};

export const MerchantTerminalNode = ({
	data,
	last,
	merchantId,
}: // onClick,
{
	data: { path: string; node: INav };
	last: boolean;
	merchantId: string;
	// onClick: (() => void) | null;
}) => {
	useLocale();
	const router = useRouter();
	const [terminal, setTerminal] = useState<ITerminal>();

	useEffect(() => {
		loadMerchantTerminal();
	}, []);

	const loadMerchantTerminal = async () => {
		const acquirerReq = await GD.REQ_MERCHANT_TERMINAL.request({
			terminalLinkID: parseInt(data.path, 10),
			merchantID: parseInt(merchantId, 10),
		});
		if (acquirerReq?.data) {
			setTerminal(acquirerReq.data);
		}
	};

	const getMerchantId = () => {
		//!TODO:;
		// if((data.node as any)['parent'])
		// {
		// 	const parent:INav = (data.node as any)['parent'];
		// 	if(parent)
		// 	{

		// 	}
		// }

		return merchantId;
	};

	const openMerchantterminal = () => {
		let params = undefined;
		if (data.node.path.indexOf(":") !== -1) {
			params = {
				[data.node.path.slice(data.node.path.indexOf(":") + 1)]: data.path,
			};
			params.tid = getMerchantId().toString();
		}
		return () => {
			router.navigate(data.node.id, params);
		};
	};

	return <Node label={terminal?.name ?? msg("terminal_4e686af7")} onClick={openMerchantterminal()} last={last} />;
};

export const Breadcrumbs = ({ showProject }: { showProject: boolean }) => {
	useLocale();
	//const presenter = usePresenter();
	const currentPath = useBreadcrumbs();
	const router = useRouter();
	const theme = useTheme() as ITheme;

	//!TODO: hook?
	const [project] = GD.B_SELECTED_PROJECT.use();
	const [user] = GD.REQ_PROFILE.useValue(undefined, undefined, [project]);

	const [isMerchant, setIsMerchant] = useState(false);

	useEffect(() => {
		if (project && user) {
			const userProject = user.projects.find(val => val.id === project.id);
			if (userProject) {
				if (hasAnyRole(userProject.roles, ["admin", "aml", "accountant", "support"])) {
					setIsMerchant(false);
				} else if (hasRole(userProject.roles, "merchant")) {
					setIsMerchant(true);
				}
			}
		}
	}, [project, user]);

	const createNode = (data: { path: string; node: INav }, index: number, attachArrow: boolean, currentPath: IBreadcrumbs[]) => {
		let label: string = data.node.id;
		let click: (() => void) | null = null;
		let content = null;
		if (data.node.path === data.node.id) {
			click = () => {
				router.navigate(data.path);
				//presenter.navChange(data.path);
			};
		} else {
			let params = undefined;
			if (data.node.path.indexOf(":") !== -1) {
				params = {
					[data.node.path.slice(data.node.path.indexOf(":") + 1)]: data.path,
				};
			}
			click = () => {
				router.navigate(data.node.id, params);
				//presenter.navChange(data.node.id, params);
			};
		}
		switch (data.node.id) {
			case "client":
				content = <ClientNode key={`${project?.id}:${data.path}`} data={data} onClick={click} last={currentPath.length - 1 === index} />;
				break;

			case "clients":
				if (currentPath[0].node.id === "clients") {
					if (isMerchant) {
						return null;
					}
					//return null;
				}

				if (isMerchant) {
					content = (
						<HBox
							onClick={() => (showProject ? openProjectSelect() : click && click())}
							sx={{
								alignItems: "center",
								lineHeight: "0px",
								cursor: "pointer",
								borderRadius: "7px",
								paddingTop: "5px",
								paddingBottom: "5px",
								paddingRight: "10px",
								paddingLeft: "10px",
								"&:hover": {
									backgroundColor: theme.colors.textPrimary + "25",
								},
							}}>
							<IconHome color={theme.colors.textPrimary} />
							<Typo
								// onClick={() => onClick && onClick()}
								sx={{
									cursor: "pointer",
									borderRadius: "7px",
									paddingTop: "5px",
									paddingBottom: "5px",
									paddingRight: "10px",
									paddingLeft: "10px",
									fontSize: "1rem",
									color: "#ff7b00",
								}}>
								{msg("branch_a968d649") + (project?.name ?? msg("dashboard"))}
							</Typo>
						</HBox>
					);
					break;
				} else {
					content = <Node label={msg("clients")} onClick={click} last={currentPath.length - 1 === index} />;
				}

				break;

			case "dashboard":
				// if (currentPath.length === 1 && currentPath[0].node.id === "dashboard") {
				// 	return null;
				// }

				if (isMerchant && data.path === "dashboard" && currentPath.length > 1) {
					content = null;
				}

				if (isMerchant && data.path === "dashboard") {
					if (currentPath.length === 1) {
						attachArrow = false;
					}

					content = (
						<HBox
							onClick={() => (showProject ? openProjectSelect() : click && click())}
							sx={{
								alignItems: "center",
								lineHeight: "0px",
								cursor: "pointer",
								borderRadius: "7px",
								paddingTop: "5px",
								paddingBottom: "5px",
								paddingRight: "10px",
								paddingLeft: "10px",
								"&:hover": {
									backgroundColor: theme.colors.textPrimary + "25",
								},
							}}>
							<IconHome color={theme.colors.textPrimary} />
							<Typo
								// onClick={() => onClick && onClick()}
								sx={{
									cursor: "pointer",
									borderRadius: "7px",
									paddingTop: "5px",
									paddingBottom: "5px",
									paddingRight: "10px",
									paddingLeft: "10px",
									fontSize: "1rem",
									color: "#ff7b00",
								}}>
								{msg("branch_a968d649") + (project?.name ?? msg("dashboard"))}
							</Typo>
						</HBox>
					);
					break;
				} else {
					content = <Node label={msg("clients")} onClick={click} last={currentPath.length - 1 === index} />;
				}
				if (currentPath.length === 1 && currentPath[0].node.id === "dashboard") {
					content = null;
				}

				if (!isMerchant && data.path === "dashboard") {
					if (currentPath.length > 0 && currentPath[0].node.id === "dashboard") {
						attachArrow = false;
					}

					content = (
						<Box
							onClick={() => click && click()}
							sx={{
								lineHeight: "0px",
								cursor: "pointer",
								borderRadius: "7px",
								paddingTop: "5px",
								paddingBottom: "5px",
								paddingRight: "10px",
								paddingLeft: "10px",
								"&:hover": {
									backgroundColor: theme.colors.textPrimary + "25",
								},
							}}>
							<IconHome color={theme.colors.textPrimary} />
						</Box>
					);
				}

				break;

			case "registerClient":
				if (data.path === "registerClient") {
					return null;
				}

				content = <Node label={msg("clientRegistration")} onClick={click} last={currentPath.length - 1 === index} />;

				break;

			case "register":
				if (data.path === "register") {
					return null;
				}

				content = <Node label={msg("clientRegistration")} onClick={click} last={currentPath.length - 1 === index} />;

				break;

			case "merchant":
				if (data.path === "merchant") {
					return null;
				} else {
					if (currentPath.length > 2) {
						content = <MerchantNode key={index} data={data} clientId={currentPath[index - 2].path} last={currentPath.length - 1 === index} />;
					}
				}
				break;

			case "provider":
				content = <AcquirerNode key={index} data={data} onClick={click} last={currentPath.length - 1 === index} />;
				break;

			case "terminal":
				content = <TerminalNode key={index} data={data} onClick={click} last={currentPath.length - 1 === index} />;
				break;

			case "providerchannel":
				if (data.path === "providerchannel") {
					return null;
				} else {
					if (currentPath.length > 2) {
						content = (
							<AcquirerChannelNode key={index} data={data} acquirerId={currentPath[index - 2].path} last={currentPath.length - 1 === index} />
						);
					}
				}
				break;

			case "merchantchannel":
				if (data.path === "channel") {
					return null;
				} else {
					if (currentPath.length > 2) {
						content = (
							<MerchantChannelNode key={index} data={data} merchantId={currentPath[index - 2].path} last={currentPath.length - 1 === index} />
						);
					}
				}
				break;

			case "merchantterminal":
				if (data.path === "terminal") {
					return null;
				} else {
					if (currentPath.length > 2) {
						content = (
							<MerchantTerminalNode key={index} data={data} merchantId={currentPath[index - 2].path} last={currentPath.length - 1 === index} />
						);
					}
				}
				break;

			default:
				switch (data.path) {
					case "clients":
						label = "Clients";
						break;
					case "users":
						label = "Users";
						break;
					case "analytic":
						label = "Analytic";
						break;
					case "register":
						label = "Register";
						break;
					case "processing":
						label = "Processing";
						break;
					case "providers":
						label = "Providers";
						break;

					case "reports":
						label = "Reports";
						break;

					case "events":
						label = "Events";
						break;

					case "terminals":
						label = "Terminals";
						break;

					default:
						label = data.node.id;
						break;
				}
				content = <Node label={label} onClick={click} last={currentPath.length - 1 === index} />;
		}
		return (
			<Fragment key={index}>
				{content}
				{attachArrow && <IconArrowRight color={theme.colors.textPrimary} />}
			</Fragment>
		);
	};

	return (
		<HBox gap="1px" sx={{ alignItems: "center" }}>
			{currentPath &&
				createNode(
					{
						node: {
							id: "dashboard",
							label: msg("home"),
							page: null as any,
							path: "/",
						},
						path: "dashboard",
					},
					-1,
					true,
					currentPath,
				)}
			{currentPath &&
				currentPath.map((val: { path: string; node: INav }, index: number) => {
					return <Fragment key={index}>{createNode(val, index, index !== currentPath.length - 1, currentPath)}</Fragment>;
				})}
		</HBox>
	);
};
